import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Importar traducciones
import esCommon from "./locales/es.json";
// ... importar otros archivos de traducción

const resources = {
  es: { common: esCommon },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "es", // Idioma por defecto del dispositivo
  fallbackLng: "es",
  ns: ["common"], // namespaces por defecto
  defaultNS: "common",
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false, // Importante para React Native
  },
});

export default i18n;
